/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <v-app :dark="isDark" class="bg">
    <SnackBar
      v-if="isSnackBar"
      :visible="isSnackBar"
      :message="getSnackBarContent['message']"
      :header="getSnackBarContent['header']"
      :icon="getSnackBarContent['icon']"
      @update:snackbar="updateSnackbar" />
    <Dialogue
      v-if="isDialog"
      :visible=isDialog
      :reference="getDialogContent['ref']"
      :header="getDialogContent['header']"
      :contents="getDialogContent['contents']"
      :icon="getDialogContent['icon']"
      :actions="getDialogContent['actions']" />
    <ProgressBar :visible="getProgressBar" />
    <router-view />
  </v-app>
</template>

<script>
import SnackBar from '@/components/utility/SnackBar.vue'
import Dialogue from '@/components/utility/Dialogue.vue'
import ProgressBar from '@/components/utility/ProgressBar.vue'
import './stylus/main.styl'
import {
  mapGetters,
  mapMutations
} from 'vuex'
/* Agathsya code starts here */

import JQuery from 'jquery'
window.$ = JQuery

/* Agathsya code ends here */
export default {
  name: 'App',
  components: {
    SnackBar,
    Dialogue,
    ProgressBar
  },
  computed: {
    ...mapGetters(['isSnackBar', 'getSnackBarContent', 'isDialog', 'getDialogContent', 'getProgressBar', 'getGeneralState']),
    isDark() {
      return this.$vuetify.breakpoint.lgAndUp ? this.getGeneralState('theme_dark') : false
    }
  },
  created() {
    window.addEventListener('beforeunload', this.REMOVE_DOWNLOAD_LIST)
  },
  mounted() {
    this.SET_PROGRESS_BAR(false)
    this.SET_SHOW_DIALOG(false)
    this.SET_SHOW_SNACKBAR(false)
  },
  methods: {
    ...mapMutations('settings', ['REMOVE_DOWNLOAD_LIST']),
    ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SHOW_DIALOG', 'SET_PROGRESS_BAR']),
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(payload)
    }
  }
}
</script>

<style>
html {
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #49516b;
  /* outline: 1px solid #49516b; */
}

::-webkit-scrollbar-track {
  border-radius: 6px;
  background-color: #B1B4B9;
  -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
}

/* ::-webkit-scrollbar-thumb:hover {
  background-color: #49516b;
  outline: 3px solid #49516b;
} */

.v-table {
  background-color: var(--v-primary-base) !important;
}

.v-datatable .v-datatable__actions {
  background-color: var(--v-primary-base) !important;
}

.v-expansion-panel .v-expansion-panel__container {
  background-color: var(--v-primary-base) !important;
}

/* To change the background color of rows on hover */
.v-datatable tbody tr:hover {
  background-color: rgba(
    255,
    255,
    255,
    0.2
  ) !important; /* Change to your desired hover background color */
  cursor: pointer;
}

/* To apply styles to the header row */
.v-datatable thead th {
  font-size: 14px !important;
  border-bottom: 1px solid #334079;
  padding: 0px 10px !important;
}

.v-datatable tbody tr:not(:last-child) {
  border-bottom: 1px solid #334079;
}
</style>
